// extracted by mini-css-extract-plugin
export default {"rating":"_y-z","numberOfStars":"az-z","count":"bz-z","barGraphSpacing":"cz-z","barGraph":"dz-z"};